var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcaseAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.657 6.486c.268.202.474.468.617.8.145.336.224.74.234 1.214l.001.105v1.351h2.555c1.967 0 2.936.96 2.936 2.899V13c-3.626 1.711-7.162 2.308-10.995 2.308-3.843 0-7.38-.597-11.005-2.308v-.145c0-1.939.979-2.899 2.936-2.899h2.555V8.605l.001-.105c.04-1.704 1.054-2.5 2.631-2.509H18.868c.75.003 1.35.164 1.789.495zM20.036 8.5v1.456h-8.072v-1.5c.018-.694.443-1.077 1.16-1.077h5.743c.368 0 .658.098.858.285.074.07.135.15.183.244a1.251 1.251 0 0 1 .128.592z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14.857v8.237c0 1.948.979 2.899 2.936 2.899h16.128c1.967 0 2.936-.95 2.936-2.899v-8.237c-2.885 1.171-5.621 1.78-8.367 1.993v.912c0 .799-.395 1.238-1.097 1.238h-3.072c-.692 0-1.087-.44-1.087-1.238v-.912c-2.756-.214-5.492-.822-8.377-1.993z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseAlt);
export default __webpack_public_path__ + "static/media/Briefcase_ALT.b7e0210d08f9b106abc080c69daff32e.svg";
export { ForwardRef as ReactComponent };